import axios from 'axios';

const request = axios.create({
  // baseURL: 'http://47.99.76.111:9090', //测试环境
  baseURL: 'https://s.focusight.top', //生产环境
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.code === 200) {
      return data?.result;
    }
    if (data.code === 401) {
      return Promise.reject(new Error('token过期'));
    }
    return Promise.reject(new Error(data.message || '请求失败'));
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      switch (status) {
        case 401:
          console.error('token过期');
          break;
        case 403:
          console.error('没有权限访问该资源');
          break;
        case 404:
          console.error('请求的资源不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          break;
        default:
          console.error(`请求失败: ${status}`);
      }
    } else if (error.request) {
      console.error('网络请求超时，请检查网络连接');
    }
    return Promise.reject(error);
  }
);

export default request;
